import { render } from "./RentPrintPage.vue?vue&type=template&id=2126b66c&scoped=true"
import script from "./RentPrintPage.vue?vue&type=script&lang=js"
export * from "./RentPrintPage.vue?vue&type=script&lang=js"

import "./RentPrintPage.vue?vue&type=style&index=0&id=2126b66c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2126b66c"]])

export default __exports__